import { AxiosResponse } from "axios";
import axios from "./api";
import { API_URL_AUTH } from '../constants/index';
import { IRegisterRequest, ILoginRequest, IForgotPasswordRequest, IForgotPasswordUserRequest, IResetPasswordRequest, IResetPasswordUserRequest, ILoginResponse } from "../interfaces/types";

type ApiResponse<T = any> = Promise<AxiosResponse<T>>;

const register = (username: string, email: string, password: string): ApiResponse => {
  const requestBody: IRegisterRequest = { username, email, password };
  return axios.post(API_URL_AUTH + "/signup", requestBody);
};

const login = (username: string, password: string): ApiResponse<ILoginResponse> => {
  localStorage.removeItem("user");
  const requestBody: ILoginRequest = { username, password };
  return axios
    .post(API_URL_AUTH + "/signin", requestBody)
    .then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response;
    });
};

const forgotPassword = (username: string): ApiResponse => {
  const requestBody: IForgotPasswordRequest = { username };
  return axios.post(API_URL_AUTH + "/forgot-password", requestBody);
};

const forgotPasswordUser = (username: string): ApiResponse => {
  const requestBody: IForgotPasswordUserRequest = { username };
  return axios.post(API_URL_AUTH + "/forgot-password-user", requestBody);
};

const resetPassword = (token: string, email: string, password: string): ApiResponse => {
  const requestBody: IResetPasswordRequest = { token, email, password };
  return axios.post(API_URL_AUTH + "/reset-password", requestBody);
};

const resetPasswordClient = (token: string, email: string, password: string): ApiResponse => {
  const requestBody: IResetPasswordRequest = { token, email, password };
  return axios.post(API_URL_AUTH + "/reset-password-client", requestBody);
};

const resetPasswordUser = (token: string, username: string, password: string): ApiResponse => {
  const requestBody: IResetPasswordUserRequest = { token, username, password };
  return axios.post(API_URL_AUTH + "/reset-password-user", requestBody);
};

const resetClientPassword = (token: string, username: string, password: string): ApiResponse => {
  const requestBody: IResetPasswordUserRequest = { token, username, password };
  return axios.post(API_URL_AUTH + "/reset-client-password", requestBody);
};

const getResetPassword = (token: string): ApiResponse => {
  return axios.get(API_URL_AUTH + "/reset-password/" + token);
};

const getResetPasswordClient = (token: string): ApiResponse => {
  return axios.get(API_URL_AUTH + "/reset-password-client/" + token);
};

const logout = (): void => {
  localStorage.removeItem("user");
};

const authService = {
  register,
  login,
  logout,
  forgotPassword,
  forgotPasswordUser,
  resetPassword,
  resetPasswordClient,
  resetPasswordUser,
  resetClientPassword,
  getResetPassword,
  getResetPasswordClient
};

export default authService;
